"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageId = void 0;
exports.resolveLocaleString = resolveLocaleString;
exports.useLocaleString = useLocaleString;
const webapi_1 = require("@fegobull/webapi");
var LanguageId;
(function (LanguageId) {
    /** 简体中文 */
    LanguageId[LanguageId["SC"] = 0] = "SC";
    /** 繁体中文 */
    LanguageId[LanguageId["TC"] = 1] = "TC";
    /** 英文 */
    LanguageId[LanguageId["EN"] = 2] = "EN";
    /** 马来语 */
    LanguageId[LanguageId["MS"] = 3] = "MS";
    /** 泰语 */
    LanguageId[LanguageId["TH"] = 4] = "TH";
    /** 日文 */
    LanguageId[LanguageId["JA"] = 5] = "JA";
    /** 德语 */
    LanguageId[LanguageId["DE"] = 6] = "DE";
    /** 法语 */
    LanguageId[LanguageId["FR"] = 7] = "FR";
    /** 意大利语 */
    LanguageId[LanguageId["IT"] = 8] = "IT";
    /** 西班牙语 */
    LanguageId[LanguageId["ES"] = 9] = "ES";
    /** 俄语 */
    LanguageId[LanguageId["RU"] = 10] = "RU";
    /** 葡萄牙语 */
    LanguageId[LanguageId["PT"] = 11] = "PT";
    /** 不匹配 */
    LanguageId[LanguageId["EOF"] = -1] = "EOF";
})(LanguageId || (exports.LanguageId = LanguageId = {}));
/**
 * 从 LocaleString 中根据指定 languageId 提取文案
 * @param localeStr  多语言对象
 * @param langId     目标语言 ID
 * @param fallbackLangId  匹配不到时的兜底语言 ID，不传则取首项
 */
function resolveLocaleString(localeStr, langId, fallbackLangId) {
    const list = localeStr?.strContext;
    if (!list || list.length === 0)
        return '';
    const matched = list.find((item) => item.languageId === langId);
    if (matched?.context)
        return matched.context;
    if (fallbackLangId != null) {
        const fallback = list.find((item) => item.languageId === fallbackLangId);
        if (fallback?.context)
            return fallback.context;
    }
    return list[0]?.context ?? '';
}
/**
 * 返回一个绑定了当前页面语言的解析函数，组件中可直接调用
 *
 * @param fallbackLangId  可选兜底语言 ID，匹配不到当前语言时优先取该语言
 *
 * @example
 * const $localeName = useLocaleString();
 * const name = $localeName(stockInfo.name);
 *
 * // 指定英文兜底
 * const $localeName = useLocaleString(3);
 */
function useLocaleString(fallbackLangId) {
    const { useLang } = webapi_1.use;
    const { lang } = useLang();
    return (localeStr) => resolveLocaleString(localeStr, lang, fallbackLangId);
}
